
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

// window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Vue.component('example', require('./components/Example.vue'));

// const app = new Vue({
//     el: '#app'
// });

require('./polyfill');

// handlebars
require('./templates');
require('./handlebars_helpers');

// plugins
require('./plugins/addressbook');
require('./plugins/shipmethods');
require('./plugins/promotion');
require('./plugins/responsiveCardCollapse');
require('./plugins/AddressValidator');

// general
require('./general');
require('./catalog_request');
require('./tax_exempt');
// require('./auth');

// sections
require('./account/address');
require('./account/orders');

require('./cart');

window.PAYPAL_CLIENT_ID = process.env.MIX_PAYPAL_CLIENT_ID;

require('./checkout/functions');
require('./checkout/validation');
require('./checkout/form');
require('./checkout/workings');
require('./checkout/guest');
require('./checkout/promo');